import { createSlice } from '@reduxjs/toolkit';
import { apiFetch } from '../utils';

export const fetchTopPlayers = () => async (dispatch) => {
    const response = await apiFetch('/user/topplayers', 'POST');
    if (response?.code === 'success') {
        dispatch(setTopPlayers(response.data));
    }
};

export const fetchNews = (startId) => async (dispatch) => {
    if (!startId) startId = 1;
    const response = await apiFetch('/user/news', 'POST', {startId});
    if (response?.code === 'success') {
      dispatch(setNews(response.data));
    };
};

const cacheSlice = createSlice({
    name: 'cache',
    initialState: { character: null, topPlayers: null, guild: null, news: null },
    reducers: {
        setCharacter: (state, action) => {
          state.character = action.payload;
        },
        setTopPlayers: (state, action) => {
          state.topPlayers = {data: action.payload, cacheTime: Date.now()};
        },
        setGuild: (state, action) => {
          state.guild = action.payload;
        },
        setNews: (state, action) => {
          state.news = action.payload;
        },
    },
});

export const { setCharacter, setTopPlayers, setGuild, setNews } = cacheSlice.actions;
export default cacheSlice.reducer;